module.exports = {"data":{"site":{"siteMetadata":{"siteUrl":"https://michel.com.es","nav":["portfolio","about"]}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-landing.json
// module id = 111
// module chunks = 60335399758886 207321357075633